export class Price {
    amount: number;
    currency: string;

    constructor() {
        this.amount = 0.0;
        this.currency = "";
    }
}